import util from '../util'

let controller = 'SplitOperacoes'
export default Object.assign({}, util.GetCrud(controller, ['get', 'getall', 'post', 'put', 'persist', 'delete']), {
  Historico(dto, options) {
    dto.data = (options.data ? options.data : {})
    return util.Axios.GetAll(controller + '/Historico', dto)
  },
  InativarLote(dto) {
    return util.Axios.Post(controller + '/InativarLote', dto)
  }
})
